import { render } from "./headerView.vue?vue&type=template&id=b96d5472&scoped=true"
import script from "./headerView.vue?vue&type=script&lang=js"
export * from "./headerView.vue?vue&type=script&lang=js"

import "./headerView.vue?vue&type=style&index=0&id=b96d5472&scoped=true&lang=less"

import exportComponent from "D:\\project\\frontend-v3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b96d5472"]])

export default __exports__